import { render } from "./AXBinventory.vue?vue&type=template&id=11054a7c&scoped=true"
import script from "./AXBinventory.vue?vue&type=script&lang=js"
export * from "./AXBinventory.vue?vue&type=script&lang=js"

import "./AXBinventory.vue?vue&type=style&index=0&id=11054a7c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-11054a7c"

export default script